import React, { useEffect } from 'react';
import Snackbar from '@mui/material/Snackbar';
import { Alert } from '@mui/material';
import { SnackbarMessageProps } from './types';

const SnackbarMessage: React.FC<SnackbarMessageProps> = (props) => {
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
        if (props.message && props.message !== '') setOpen(true);
    }, [props.message]);

    const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
        if (props.clearMessage) props.clearMessage();
    };

    return (
        <Snackbar
            open={open}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            className="error-snackbar"
            autoHideDuration={props.autoHideDuration || 6000}
        >
            <Alert severity={props.serverity} variant="outlined" sx={{ width: '100%', backgroundColor: 'white' }}>
                {props.message}
            </Alert>
        </Snackbar>
    );
};

export default SnackbarMessage;
